module.exports = __webpack_public_path__ + "media/images/logo-calderon-5247894d0ffd2f66ae3908ef0bd42b71.png";